export default "__VITE_ASSET__D8nKLr0R__"